import axios from 'axios';
import { NOWID_PROXY_URL } from '../../../../config';

const getProxyCandidates = () => {
  const configured = [
    NOWID_PROXY_URL,
    '/api/nowid-proxy.php',
    '/api/nowid-proxy',
  ].filter(Boolean);

  // Ensure both variants are available for each configured path.
  const expanded = [];
  configured.forEach((url) => {
    if (expanded.includes(url)) return;
    expanded.push(url);

    if (url.endsWith('.php')) {
      const withoutPhp = url.replace(/\.php$/, '');
      if (!expanded.includes(withoutPhp)) expanded.push(withoutPhp);
      return;
    }

    if (!expanded.includes(`${url}.php`)) expanded.push(`${url}.php`);
  });

  return expanded;
};

export const verifyToken = async (token) => {
  const payload = token ? { token } : {};
  if (typeof navigator !== 'undefined' && navigator.userAgent) {
    payload.userAgent = navigator.userAgent;
  }
  // Add timestamp to prevent caching
  payload.t = Date.now();

  const requestBody = {
    proxyTarget: 'nowid',
    endpoint: 'api/verifytoken',
    method: 'POST',
    payload,
  };

  const proxyCandidates = getProxyCandidates();
  let lastError;

  for (const proxyUrl of proxyCandidates) {
    try {
      const response = await axios.post(proxyUrl, requestBody);
      return response.data;
    } catch (error) {
      lastError = error;

      // Retry on routing / server errors with the next candidate.
      const status = error?.response?.status;
      if (status === 404 || status === 405 || status === 502 || !status) {
        continue;
      }

      throw error;
    }
  }

  throw lastError;
};
